module.exports = "/images/noun-winter-sport-3456176.svg?9e9afc0396ed73b695a2c7d1b2f67a51";